import React from "react";
import { SortIcon } from "./SortIcon";
import styles from "../TokensTable.module.scss";
import tableColStyles from "../TableColumns.module.scss";

interface ColumnHeaderButtonProps {
  colKey: string;
  label: string;
  active: boolean;
  sortDir: "asc" | "desc";
  onSort: (key: string) => void;
  getColumnClass: (colKey: string) => string;
  isVisible: boolean;
  colClass: string;
}

export const ColumnHeaderButton: React.FC<ColumnHeaderButtonProps> = ({
  colKey,
  label,
  active,
  sortDir,
  onSort,
  getColumnClass,
  isVisible,
  colClass,
}) => {
  if (!isVisible) return null;
  return (
    <button
      className={`${tableColStyles.tableCellHeader} ${tableColStyles.tableCol} ${colClass} ${active ? styles.activeSort : ''} ${getColumnClass(colKey)}`}
      style={active ? { color: 'var(--white-opacity-white-70, rgba(245, 248, 255, 0.70))' } : {}}
      onClick={() => onSort(colKey)}
      type="button"
      aria-pressed={active}
      aria-label={`Sort by ${label}`}
    >
      {label}
      {active && <SortIcon dir={sortDir} />}
    </button>
  );
};
